import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-blank-casual',
  templateUrl: './blank-casual.component.html',
  styleUrls: ['./blank-casual.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlankCasualComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
